/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassroomdisciplineIdUsersPersonidAvailableClassStudents200,
  GetApiV1ClassroomdisciplineIdUsersPersonidAvailableClassStudents401,
  GetApiV1ClassroomdisciplineIdUsersPersonidAvailableClassStudents404,
  GetApiV1ClassroomdisciplineIdUsersPersonidAvailableClassStudentsPathParams,
  GetApiV1ClassroomdisciplineIdUsersPersonidAvailableClassStudentsQueryResponse,
} from "../../types/classPlanningPeopleController/GetApiV1ClassroomdisciplineIdUsersPersonidAvailableClassStudents.ts";
import { availableClassStudentViewModelSchema } from "../availableClassStudentViewModelSchema.ts";

export const getApiV1ClassroomdisciplineIdUsersPersonidAvailableClassStudentsPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
    personId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1ClassroomdisciplineIdUsersPersonidAvailableClassStudentsPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassroomdisciplineIdUsersPersonidAvailableClassStudents200Schema =
  z.array(
    z.lazy(() => availableClassStudentViewModelSchema),
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineIdUsersPersonidAvailableClassStudents200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassroomdisciplineIdUsersPersonidAvailableClassStudents401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdUsersPersonidAvailableClassStudents401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ClassroomdisciplineIdUsersPersonidAvailableClassStudents404Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdUsersPersonidAvailableClassStudents404>;

export const getApiV1ClassroomdisciplineIdUsersPersonidAvailableClassStudentsQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1ClassroomdisciplineIdUsersPersonidAvailableClassStudents200Schema,
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineIdUsersPersonidAvailableClassStudentsQueryResponse>;
